import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

export const HowToContainer = styled.div`
  overflow: hidden;
  padding: 3.75rem 0;

  @media screen and ${min('largeTablet')} {
    padding: 5rem 0;
  }
`;

export const LoaderContainer = styled.div`
  padding: 3rem 2rem 0;
`;

export const Details = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1rem;
  margin-top: 1rem;
  text-align: center;

  @media screen and ${min('largeTablet')} {
    text-align: left;
    font-size: 1.125rem;
  }
`;

interface IDoublePushContainerProps {
  centered?: boolean;
}

export const DoublePushContainer = styled(motion.div)<IDoublePushContainerProps>`
  display: flex;
  flex-direction: column;
  margin: 0 -1rem;

  @media screen and ${min('largeTablet')} {
    flex-direction: row;
    align-items: ${({ centered }) => (centered ? 'center' : 'stretch')};
  }
`;

export const PushContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  padding: 1rem;

  @media screen and ${min('largeTablet')} {
    flex: 0 0 50%;
    max-width: 50%;
    margin-top: 2rem;
  }
`;

export const CaptionContainer = styled.div``;

export const CaptionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  svg {
    margin-right: 1rem;
    display: none;

    @media screen and ${min('tablet')} {
      display: block;
    }
  }
`;

export const CaptionTitle = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  font-size: 1.125rem;
  margin-bottom: 0;

  @media screen and ${min('largeTablet')} {
    font-size: 1.25rem;
  }
  span {
    color: ${({ theme }) => theme.colors.Carnation};
  }
`;

export const CaptionDescription = styled.p`
  font-size: 1rem;
  margin-bottom: 1.25rem;

  @media screen and ${min('tablet')} {
    margin-bottom: 1.5rem;
  }
  @media screen and ${min('largeTablet')} {
    font-size: 1.125rem;
    margin-bottom: 1.875rem;
  }
`;
